import { Record } from 'immutable'


const FreeMail = Record({
  title:null,
  body:null
});
export default FreeMail;
